import { createContext } from 'react';

export const IntegrationContext = createContext({
  isCleverIntegration: false,
  dataImportPath: '/data-import-new',
});
